import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ReViewScurety from "./ReViewScurety";
import { change_Lang } from "../../../actions/Helper_action";
import {
  Update_ScuretyBill,
  View_Scurety,
} from "../../../actions/Invoice_action";
export class View_Scurety_component extends Component {
  render() {
    const {
      scurety_view,
      lang,
      change_Lang,
      user,
      Update_ScuretyBill,
      handleCancel,
    } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <ReViewScurety
            scurety_view={scurety_view}
            lang={lang}
            change_Lang={change_Lang}
            user={user}
            Update_ScuretyBill={Update_ScuretyBill}
            handleCancel={handleCancel}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    scurety_view: state.InvoiceReducer.scurety_view,
    list_scurety: state.InvoiceReducer.list_scurety,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Scurety: (id) => dispatch(View_Scurety(id)),
    Update_ScuretyBill: (id, data) => dispatch(Update_ScuretyBill(id, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(View_Scurety_component);
